import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface ParticipantsListLabelsProps {
	settings: SearchProps,
	annualEnrollmentDisabled: boolean,
}

export const ParticipantsListLabels = (props: ParticipantsListLabelsProps) => {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.participantClientNumberLabel} name='masked_client_number' />
			</div>
			<div className='sort-table-row-cell icon-row-title'>
				<SortButton label={props.settings?.participantNameLabel} name='full_name' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.participantCityLabel} name='mailing_address_city' />
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.participantDependentLabel}</p>
			</div>
			{
				!props.annualEnrollmentDisabled &&
				<div className='sort-table-row-cell'>
					<SortButton label={props.settings?.annualEnrollmentStatusLabel} name='oe_status' />
				</div>
			}
			{
				!props.annualEnrollmentDisabled &&
				<div className='sort-table-row-cell'>
					<SortButton label={props.settings?.annualEnrollmentActionLabel} name='ae_available_text' />
				</div>
            }
		</div>
	);

};
